import type { IVisitaRepository } from '@/domain/repositories/IVisitaRepository';

export class GetVisitasUseCase {
  constructor(private readonly repository: IVisitaRepository) {}

  execute() {
    return this.repository.findAll();
  }
}
